module.exports = __webpack_public_path__ + "static/media/mobile.46f4e3bc.svg";